<template>
<div style="border:0px solid black; height:30px">
    <div class="divContenido">
        <!--<input :type="tipo" v-model="value_data" @change="change" @focus="onfocus" @blur="onblur" :class="{'cajaTexto':true,'campoError':hay_error}" :disabled="disabled" :placeholder="placeholder" @keyup="keypress" :size="size" :maxlength="maxlength"
            :style="style" />-->

       <v-text-field v-model="texto_value" :label="label" :rules="[rules.fecha]" @input="change" placeholder="dd/mm/yyyy" hint="dd/mm/yyyy" 
                      persistent-hint postpend-icon="event" dense clearable maxlength="10"  />

    </div>
</div>
</template>

<script>

//import {esNumeroMovil,esEmail,is_numeric} from '@/library/misFunciones.js';
import {fecha_correcta, getParametro} from '@/library/misFunciones.js';

export default {
    name: 'ControlFechaTexto',   
    data() {
        return {
            cargando:false,
            date_value: null,
            texto_value: '',
            //value_data:'',
            mensaje_error: '',
            //foco: false,
            rules: {
                fecha: v => this.fecha_correcta_local(v),
            },
           
        }
    },
    computed: {
        hay_error(){
            if (this.mensaje_error) return true;
            else return false
        },

    },
    props: {
        label: String,
        value: String,
        size: {type: Number, required: false, default: 25},
        // maxlength: {type: String, required: false, default: '200'},
        // height: {type: Number, required: false, default: 30},
        // width: {type: String, required: false, default: ''},
        font_size: {type: String, required: false, default: '12'},
        placeholder: String,
        obligatorio: {type: Boolean, required: false, default: false},
        // type: {type: String, required: false, default: 'text'},
        // entero: {type: Boolean, required:false, default: false}, //Solo se usa para type=number
        // positivo: {type: Boolean, required:false, default: false},//Solo se usa para type=number
        mensaje_when_error: {type: String, required: false, default: ''},
        disabled: Boolean,
      
    },
    watch: {
  
    //   value: { immediate: true, handler(newval, oldval) {
    //             this.value_data = newval;
    //      }, 
    //   },        
      value: { immediate: true, handler(newval, oldval) {
                //this.value_data = newval;
                // console.log("watch value",newval)
            if (!newval) {
                this.date_value = null;
                this.texto_value = '';
            }
            else {
              if (typeof newval =="string") {
                this.date_value = newval.substring(0,10);
                this.texto_value = this.date_to_string(newval.substring(0,10))
              } 
            }
         }, 
      },        
    },    
    methods: {
        getParametro,

        fecha_correcta_local(v) {

        //   console.log("obligatorio",this.obligatorio,v)
          if (this.obligatorio && (!v || v.length==0)) return this.$i18n.t("fechaobligatoria");;
          if (!fecha_correcta(v)) return this.$i18n.t("fechaincorrecta");
          return true;
        },

        date_to_string(fecha) {
          if (!fecha) return null
          const [year, month, day] = fecha.split('-')
          return `${day}/${month}/${year}`          
        },
        string_to_date(fecha) {           
          if (!fecha) return null
          const [day, month, year] = fecha.split('/')
          return `${year}-${month}-${day}`          
        },
        change(){
            // console.log("change",this.texto_value)
            if (fecha_correcta(this.texto_value)) {
                this.date_value = this.string_to_date(this.texto_value)
                // console.log("date_value",this.date_value)
                this.$emit('input',this.date_value)
                this.$emit('change',this.date_value)
            }

        },
      
       
       
    },
      

}

</script>

<style scoped>
 .cajaTexto {
  border: 1px solid gray;
  border-radius: 4px;
  padding-top : 6px;
  padding-bottom: 6px;
  padding-left: 3px;
  color: rgb(30,30,30); 
 }
  .cajaTexto:focus {
    border-color:darkblue;
    border: 1px solid gray;
    outline: 1px solid rgb(70,70,250);    

 } 
 .campoError {
     background-color: red;    
 }
 .divTitle {
   /* border:1px solid black;  */
   position: relative;
   left: 7px;
   top: -12px; 
   height: 15px;
   z-index: 1;
   font-size: 11px;
   background-color:white; 
   display: inline-block;
   padding-left: 3px;
   padding-right: 3px;

   /* text-shadow: 0 0 0px white; */
 }
 .divContenido {
   position: relative;
   left: 0px;
   top: 0px; 
 }


  
</style>
